import { Component, Input, OnInit } from "@angular/core";

import { Settings } from "@hermes/app-core";

@Component({
    selector: "h-loading-screen",
    templateUrl: "./loading-screen.component.html",
    styleUrls: ["./loading-screen.component.scss"],
})
export class LoadingScreenComponent implements OnInit {
    /** Boolean to know if should display a loader */
    @Input()
    public loading: boolean;

    public imgSrc: string;

    constructor(private settings: Settings) {}

    public ngOnInit(): void {
        this.initLoadingScreen();
    }

    /**
     * Function to get the loader icon randomly
     */
    public initLoadingScreen() {
        const loaderVariant = Math.floor(Math.random() * 6);
        this.imgSrc = `url('${this.settings.assetsUrlEditoContent}Loader/loader-${loaderVariant}.gif')`;
    }
}
